<template>
  <div id="pricing" class="pricing-wrap pt-100 pb-75">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style3 text-center mb-40">
            <span>Our Pricing Plan</span>
            <h2>
              Our High Quality <span> Easy Price</span> Without Any Hidden Fees
            </h2>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div
          class="col-xl-4 col-lg-6 col-md-6"
          v-for="pricing in pricings"
          :key="pricing.id"
        >
          <div class="pricing-table style8">
            <div class="pricing-header">
              <h5>{{ pricing.title }}</h5>
              <div class="pricing-header-tag">
                <h3>
                  ${{ pricing.price }} <span>/Per {{ pricing.period }}</span>
                </h3>
              </div>
            </div>

            <div class="pricing-features">
              <h5>Our Best Features:</h5>
              <ul class="list-style">
                <li
                  v-for="feature in pricing.features"
                  :key="feature.id"
                  :class="feature.class"
                >
                  {{ feature.text }}
                </li>
              </ul>
            </div>
            <div class="purchase-pricing">
              <a href="#" class="btn style1">Choose This Plan</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "OurPricing",
  data: () => ({
    pricings: [
      {
        id: 1,
        title: "Starter",
        price: "15",
        period: "month",

        features: [
          {
            id: 1,
            class: "checked",
            text: "Cancer Services",
          },
          {
            id: 2,
            class: "checked",
            text: "Cardiovascular Services",
          },
          {
            id: 3,
            class: "checked",
            text: "Weight Management",
          },
          {
            id: 4,
            class: "checked",
            text: "Dental Services",
          },
          {
            id: 5,
            class: "unchecked",
            text: "Womens Health",
          },
          {
            id: 6,
            class: "unchecked",
            text: "Emergency Medicine",
          },
          {
            id: 7,
            class: "unchecked",
            text: "Family Medicine",
          },
        ],
      },
      {
        id: 2,
        title: "Professional",
        price: "35",
        period: "month",

        features: [
          {
            id: 1,
            class: "checked",
            text: "Cancer Services",
          },
          {
            id: 2,
            class: "checked",
            text: "Cardiovascular Services",
          },
          {
            id: 3,
            class: "checked",
            text: "Weight Management",
          },
          {
            id: 4,
            class: "checked",
            text: "Dental Services",
          },
          {
            id: 5,
            class: "checked",
            text: "Womens Health",
          },
          {
            id: 6,
            class: "unchecked",
            text: "Emergency Medicine",
          },
          {
            id: 7,
            class: "unchecked",
            text: "Family Medicine",
          },
        ],
      },
      {
        id: 3,
        title: "Institution",
        price: "55",
        period: "month",

        features: [
          {
            id: 1,
            class: "checked",
            text: "Cancer Services",
          },
          {
            id: 2,
            class: "checked",
            text: "Cardiovascular Services",
          },
          {
            id: 3,
            class: "checked",
            text: "Weight Management",
          },
          {
            id: 4,
            class: "checked",
            text: "Dental Services",
          },
          {
            id: 5,
            class: "checked",
            text: "Womens Health",
          },
          {
            id: 6,
            class: "checked",
            text: "Emergency Medicine",
          },
          {
            id: 7,
            class: "checked",
            text: "Family Medicine",
          },
        ],
      },
    ],
  }),
});
</script>